import React from 'react';
import {BoilerInputProps, ClassBuilder, Input } from 'b302-frontend-library';

import AutoResizableInput from './AutoResizableInput';
import ErrorList from './ErrorList';

interface Props<T> extends BoilerInputProps<T> {
    autoResize?: boolean;
    children?: any;
    placeholder?: string;
    showErrors?: boolean;
}

function HanInput<T>(props: Props<T>) {
    const className = ClassBuilder
        .createClass('han-input__input')
        .addIf(props.className, props.className)
        .build();

    const errors = props.form.errors[props.id];
    const hasError = errors && errors.length > 0;

    return (
        <div className={'han-input__container'}>
            <div className={`han-input ${hasError ? 'han-input--error' : ''}`}>
                {props.children && <div className="han-input__icon">{props.children}</div>}
                {
                    props.autoResize ?
                        <AutoResizableInput
                            form={props.form}
                            id={props.id}
                            onChange={props.onChange}
                        />
                        :
                        <Input
                            type={'text'}
                            className={className}
                            id={props.id}
                            placeholder={props.placeholder}
                            form={props.form}
                            onChange={props.onChange}/>
                }
            </div>

            { (props.showErrors && hasError) &&
                <ErrorList errors={errors ?? []} />
            }
        </div>
    );
}

export default HanInput;
